import React, { Component } from 'react';
import {connect} from "react-redux";

import {startedValuationImport} from "../../redux/actions";
import Toolbar from "../reusables/Toolbar";
import DynamicExcelTools from "../reusables/DynamicExcelTools";
import PrivateCoreService from "../../services/PrivateCoreService";

class ValuationOverview extends Component {
    constructor(props) {
        super(props);
        this.customerId = props.match.params.id;
        this.state = { };
    }

    postSingle(data, query, callback) {
        let customer = this.props.currentCustomer;
        let jwt = this.props.privateCoreJwt[this.customerId];
        let service = new PrivateCoreService(this.props.dispatch);

        data['valuationSource'] = process.env.REACT_APP_VALUATION_IMPORT_SOURCE ? process.env.REACT_APP_VALUATION_IMPORT_SOURCE : 'OFFICIAL';
        service.postValuation(customer, jwt, data, query, callback);
    }

    render() {
        return (
            <div>
                <Toolbar>
                    <DynamicExcelTools fileName="valuations" subject="valuation"
                                       startImportAction={startedValuationImport()}
                                       purgeEmptyAttributes={true}
                                       postSingleEntry={ (entry, query, callback) => this.postSingle(entry, query, callback)}
                                       requiredColumns={['valuationReference']}/>
                </Toolbar>

            </div>
        );
    }
}

const mapStateToProps = ({
    currentCustomer,
    privateCoreJwt
}) => ({
    currentCustomer,
    privateCoreJwt
});

const mapDispatchToProps = (dispatch) => ({dispatch});

export default connect(mapStateToProps, mapDispatchToProps)(ValuationOverview);



// WEBPACK FOOTER //
// ./src/components/valuations/ValuationOverview.js